<template>
  <div>
    <div class="columns fastAnimation" v-if="step === STEPS.CALENDAR_LOADING">
      <div class="column">
        Chargements
      </div>
    </div>
    <div class="fastAnimation" v-if="step === STEPS.CALENDAR_SELECT">
      <div class="column has-bg-light">
        Sélectionnez un calendrier
      </div>
      <div class="column is-relative">
        <div class="box3-top"></div>
        <div v-for="c in calendars" class="field">
          <input v-model="calendar"
            :id="c.id"
            type="radio"
            :value="c.id"
            name="calendrier"
            @change="calendarSelection"
            class="switch is-rounded"><label :for="c.id">{{c.summary}}</label><!-- is-checkradio -->
        </div>
      </div>
    </div>
    <div class="column is-paddingless-bottom" v-if="step === STEPS.EVENT_EXPORT">
      Exporter le rendez-vous <b>{{event.rdv_type}} avec {{event.contact_name}}</b> vers mon calendrier Google ?
    </div>
  </div>
</template>

<script>
  import { isNil } from 'lodash'
  import { GoogleMx } from '@/mixins'

  const STEPS = {
    CALENDAR_LOADING: 'CALENDAR_LOADING',
    CALENDAR_SELECT: 'CALENDAR_SELECT',
    EVENT_EXPORT: 'EVENT_EXPORT'
  }

  export default {
    name: 'GoogleExport',
    props: {
      event: {
        type: Object,
        required: true
      }
    },
    mixins: [ GoogleMx ],
    data () {
      return {
        calendar: null,
        calendars: [],
        step: STEPS.CALENDAR_LOADING,
        STEPS: STEPS
      }
    },
    computed: {},
    methods: {
      canSubmit () {
        if (this.step === STEPS.CALENDAR_LOADING) {
          return false
        } else if (this.step === STEPS.CALENDAR_SELECT) {
          return isNil(this.calendar) === false
        } else if (this.step === STEPS.EVENT_EXPORT) {
          return true
        } else {
          return false
        }
      },
      calendarSelection () {
        if (isNil(this.calendar) === false) {
          this.step = STEPS.EVENT_EXPORT
        }
      },
      loadCalendars () {
        window.gapi.client.calendar.calendarList.list({})
          .then((r) => {
            this.calendars = r.result.items.filter(x => x.accessRole !== 'reader')
            this.step = STEPS.CALENDAR_SELECT
          })
      },
      submit () {
        if (!this.canSubmit) {
          console.log('cant submit')
        } else {
          if (this.step === STEPS.CALENDAR_SELECT) {
            this.step = STEPS.EVENT_EXPORT
          } else if (this.step === STEPS.EVENT_EXPORT) {
            this.createRdvInGoogle(this.event)
          }
        }
      }
    },
    created () {
      this.loadCalendars()
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/quickview/GoogleExport.vue